import { render, staticRenderFns } from "./customer-service.vue?vue&type=template&id=58e9d839&"
import script from "./customer-service.vue?vue&type=script&lang=js&"
export * from "./customer-service.vue?vue&type=script&lang=js&"
import style0 from "./customer-service.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports